import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, inject } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})
export class CookieStorageService extends CookieService implements Storage {
    @Inject(DOCUMENT) private dom: Document = inject(DOCUMENT);

    public length: number = 1;

    public clear(): void {
        // This is intentional
    }

    public getItem(key: string): string | null {
        return this.get(key);
    }

    public key(): string | null {
        return null;
    }

    public removeItem(key: string): void {
        return this.delete(key, '/');
    }

    public setItem(
        key: string,
        value: string,
        expires: number | Date = null,
        path: string = '/',
        domain: string = `${this.dom.location.hostname.replace(/^www\./, '')}`,
        secure: boolean = true,
    ): void {
        // const cookieDomain = this._isLocalhost(domain) ? null : domain;
        return this.set(key, value, expires, path);
    }

    // private _isLocalhost(url: string) {
    //     return url.includes('localhost') || url.includes('127.0.0.1');
    // }
}
